import { HttpHeaders } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { AppStateInterface } from 'app/core/app-config/state/models';
import { TokenInterface } from 'app/core/authentication/models';
import { UserInterface } from 'app/core/user/models';
import { BehaviorSubject } from 'rxjs';

export abstract class RestConnectorService {

  // used by implementation classes for /api/users/{userId}/* style REST API endpoints
  protected readonly _authenticatedUser$: BehaviorSubject<UserInterface> = new BehaviorSubject<UserInterface>(undefined);

  protected constructor(protected readonly _aStore: Store<AppStateInterface>) {

    // subscribe to .authenticatedUser$ from the ngrx Store directly. This keeps Services 100% independent of one another
    // and relies on only ngrx Store for cross ngModule Service interactions. Compared to DI with the AuthService.
    this._aStore.select(({ auth }: AppStateInterface) => auth && auth.token)
      .subscribe((authToken: TokenInterface) => {
        if(authToken && authToken.loggedInUser) {
          this._authenticatedUser$.next(authToken.loggedInUser);
        }
      });
  }

  public getHttpHeaders(): HttpHeaders {
    const httpHeaders: HttpHeaders = new HttpHeaders();
    httpHeaders.append('Content-Type', 'application/json');
    return httpHeaders;
  }
}
